export default __webpack_public_path__ + "static/media/leekmap4.8d5320bd.png";